
export function BlueStats() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="11"
        height="11"
        fill="none"
        viewBox="0 0 11 11"
      >
        <path
          stroke="#0767F4"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.1"
          d="M9.721 7.283a4.583 4.583 0 11-6.054-5.986M10.083 5.5A4.583 4.583 0 005.5.917V5.5h4.583z"
        ></path>
      </svg>
    );
  }